import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/navigation';

// Utils
import { cn } from 'utils';
// Styles
import styles from './PresentationBlock.module.css';

// Components
import Tag from '../../atoms/Tag/Tag';
import Button from '../../atoms/Button/Button';
import OpeningDateTag from '../OpeningDateTag/OpeningDateTag';

function PresentationBlock({
  title,
  residence,
  address,
  full,
  openingDate,
  bookingUrl,
  phone,
  displayBooking,
  theme,
  className,
}) {
  const { t } = useTranslation();
  const { push } = useRouter();

  return (
    <div className={cn([styles.wrapper, styles[theme], className])}>
      <div className={styles.container}>
        {title ? (
          <h1 className={styles.title}>{title}</h1>
        ) : null}

        <div className={styles.tags}>
          {full ? (
            <Tag content={full ? t('presentationBlock.full') : t('presentationBlock.open')} />
          ) : null}
          <OpeningDateTag openingDate={openingDate} />
        </div>

        <div className={styles.address}>
          {residence ? (
            <span className={styles.item}>{residence}</span>
          ) : null}
          {address && residence ? (
            <span className={styles.separator} />
          ) : null}
          {address ? (
            <a href="#map" className={cn([styles.item, styles.underline])}>{address}</a>
          ) : null}
          {(address && phone) || (residence && phone) ? (
            <span className={styles.separator} />
          ) : null}
          {phone ? (
            <a href={`tel:${phone}`} className={styles.phone} aria-label="phone">
              {phone}
            </a>
          ) : null}
        </div>

        {bookingUrl && displayBooking ? (
          <Button
            outline
            onClick={() => push(bookingUrl)}
            className={cn([styles.buttonBooking, styles.mobile])}
          >
            {t('residence.booking')}
          </Button>
        ) : null}
      </div>
    </div>
  );
}

PresentationBlock.propTypes = {
  title: PropTypes.string,
  residence: PropTypes.string,
  address: PropTypes.string,
  full: PropTypes.bool,
  openingDate: PropTypes.string,
  phone: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark', 'neutral', '']),
  className: PropTypes.string,
  bookingUrl: PropTypes.string,
  displayBooking: PropTypes.bool,
};

PresentationBlock.defaultProps = {
  title: '',
  residence: '',
  address: '',
  full: false,
  openingDate: '',
  phone: '',
  theme: 'light',
  className: '',
  bookingUrl: '',
  displayBooking: false,
};

export default PresentationBlock;
